module.exports = __webpack_public_path__ + "img/490-277e98.png";